import { Box, Stack } from '@mui/material';
import BoxIcon from '@shared/components/BoxIcon';
import AppTheme from '@libs/mui/AppTheme';
import SmsSendDialog from '../../../sms/components/SmsSendDialog';
import { Paths } from '@shared/AppRoutes';
import PhotoCameraFrontOutlinedIcon from '@mui/icons-material/PhotoCameraFrontOutlined';
import SendIcon from '@mui/icons-material/Send';
import { HasVisitId } from '../../entity';
import { HasClientId } from '../../../client/entity';
import { useAppNavigate } from '@shared/store';
import { useEffect, useRef, useState } from 'react';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';

type VisitActionButtonsProps = HasVisitId & HasClientId;

const VisitActionButtons = (props: VisitActionButtonsProps) => {
  const { clientId, visitId } = props;
  const navigate = useAppNavigate();
  const sendSmsDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const [isSmsDialogMounted, setIsSmsDialogMounted] = useState(false);

  useEffect(() => {
    if (isSmsDialogMounted) {
      sendSmsDialogRef.current?.open();
    }
  }, [isSmsDialogMounted]);

  return (
    <Box
      sx={{
        cursor: clientId ? 'pointer' : 'default',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack direction="row" spacing={1}>
        <BoxIcon
          size="small"
          onClick={() => {
            if (isSmsDialogMounted) {
              sendSmsDialogRef.current?.open();
            } else {
              setIsSmsDialogMounted(true);
            }
          }}
          sx={{
            background: `${AppTheme.palette.common.white}`,
            color: `${AppTheme.palette.info.main}`,
          }}
          icon={<SendIcon fontSize="small" color="info" />}
        />

        <BoxIcon
          onClick={() => navigate(Paths.visitDetail(clientId, visitId))}
          size="small"
          boxColor="#61fb0133"
          sx={{
            background: `${AppTheme.palette.common.white}`,
            color: `${AppTheme.palette.info.main}`,
          }}
          icon={<PhotoCameraFrontOutlinedIcon fontSize="small" color="primary" />}
        />
      </Stack>
      {isSmsDialogMounted && (
        <SmsSendDialog sendSmsDialogRef={sendSmsDialogRef} visitId={visitId} />
      )}
    </Box>
  );
};

export default VisitActionButtons;
